// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background:
        'linear-gradient(90deg, rgba(36, 158, 178, 0.9) 0%, rgba(101, 194, 175, 0.9) 100%)',
      '& .MuiBackdrop-root': {
        backgroundColor: 'transparent',
      },
    },
    buttonClose: {
      display: 'inline-block',
      float: 'right',
      marginRight: theme.spacing(-2),
      marginTop: theme.spacing(-2),
    },
  }),
);

export default useStyles;
